<mat-accordion class="dnd-accordion">
    <mat-expansion-panel disabled class="dnd-accordion-expansion-panel" (click)="accordionClickHandler($event)" (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Accordion Group
        </mat-panel-title>
        <!-- <mat-panel-description>
          Currently I am {{panelOpenState ? 'open' : 'closed'}}
        </mat-panel-description> -->
      </mat-expansion-panel-header>
      <div class="dnd-accordion-field-type-item-body">
        Add child fields from the right panel
        <mat-icon>arrow_right_alt</mat-icon>
      </div>
  
    </mat-expansion-panel>
  </mat-accordion>